import {I18n} from "i18n-js";
import {TranslateOptions} from "i18n-js/src/typing";
import {Locale, UserSettingsApi} from "api/UserSettingsApi";
import {UserState, useUserState} from "store/user-store";
import {StringKey} from "./keys";

const NONE_LOCALE = "none"

const i18n = new I18n({
    en: {
        greeting: "Hello %{name}!",
        "test-key": "Test key"

    },
    lt: {
        greeting: "Labas %{name}!",
        "test.key": "Test key"
    },
    pl: {
        greeting: "Cześć %{name}!",
        "test.key": "Test key"
    }
});

i18n.missingBehavior = "custom-missing";
i18n.enableFallback = true;
i18n.defaultLocale = "en";
i18n.defaultSeparator = "__"; // workaround for nested keys, to allow use flat structure with dots

i18n.missingTranslation.register("custom-missing", (i18nUsed, scope) => {
    const scopeStr = Array.isArray(scope) ? scope.join(".") : scope;
    if(isTranslateMode()) {
        return `{{${scopeStr}}}`;
    }
    return `Err: ${scopeStr}`;
});

// load current locale lang bundle
function loadTranslations() {
    if(isTranslateMode()) {
        console.log("Translate mode enabled, skipping loading translations")
        return;
    }

    const locale = i18n.locale as Locale;
    UserSettingsApi.getLanguageBundle(locale).then((response) => {
        if (response.data) {
            i18n.store(response.data);
            console.log("Loaded locale bundle", response.data)
        }
    });
}

function setupLocale(state?: UserState) {
    const usedState = state ?? useUserState.getState();
    i18n.locale = usedState.getLanguage()
    console.log("Locale set to", i18n.locale)

    loadTranslations()
}

// setup locale on app load, or update it when user changes
if (useUserState.getState().isCurrentUserLoaded) {
    setupLocale()
}

useUserState.subscribe((state) => {
    console.log("User state changed, updating locale...")
    setupLocale(state)
});


export function isTranslateMode() {
    return i18n.locale === NONE_LOCALE;
}

export default function T(key: Readonly<StringKey>, options?: TranslateOptions) {
    return i18n.t(key, options);
}




